import React, { useState, useEffect, useContext } from "react";
import {
  OMNISCAN_CORPORATE_RED,
  OMNISCAN_CORPORATE_GREEN,
  OMNISCAN_CORPORATE_TURQUOIS,
  OMNISCAN_CORPORATE_PINK,
  OMNISCAN_CORPORATE_PURPLE
} from "../../../constants/colors";

export default function AssetChartAVailability() {
	
	const chartContainer = {
	       height: "150px",
	       borderRadius: "14px",
	       background: "linear-gradient(180deg, #0e0f12 0%, #0a0b0e 100%)",
	       border: "1px solid rgba(255,255,255,0.06)",
	       overflow: "hidden"
	   };
	
	const OMNI = {
	       TURQUOIS: OMNISCAN_CORPORATE_TURQUOIS,
	       GREEN: OMNISCAN_CORPORATE_GREEN,
	       RED: OMNISCAN_CORPORATE_RED,
	       PINK: OMNISCAN_CORPORATE_PINK,
	       PURPLE: OMNISCAN_CORPORATE_PURPLE
	   };
	   
	   const availabilityData = React.useMemo(function () {
	          return generateAvailabilityData(120);
	      }, []);

	      const AVAIL_TARGET = 99.0;
	   
	   function adjustColor(hex, amount) {
	         let color = hex.replace("#", "");

	         let r = parseInt(color.substring(0, 2), 16);
	         let g = parseInt(color.substring(2, 4), 16);
	         let b = parseInt(color.substring(4, 6), 16);

	         r = Math.min(255, Math.max(0, r + amount));
	         g = Math.min(255, Math.max(0, g + amount));
	         b = Math.min(255, Math.max(0, b + amount));

	         return (
	             "#" +
	             r.toString(16).padStart(2, "0") +
	             g.toString(16).padStart(2, "0") +
	             b.toString(16).padStart(2, "0")
	         );
	     }
	
		 function AvailabilityTimeline({ data, height, target }) {

		       const min = 94;
		       const max = 100;
		       const stepX = 6;

		       function y(v) {
		           return height - ((v - min) / (max - min)) * height;
		       }

		       let d = "";

		       data.forEach(function (v, i) {
		           const x = i * stepX;
		           const yy = y(v);

		           if (i === 0) {
		               d += "M " + x + " " + yy;
		           } else {
		               const px = (i - 1) * stepX;
		               const py = y(data[i - 1]);
		               const cx = (px + x) / 2;

		               d += " Q " + cx + " " + py + ", " + x + " " + yy;
		           }
		       });

		       return (
			
		           <svg width="100%" height={height}>

		               <line
		                   x1="0"
		                   x2={data.length * stepX}
		                   y1={y(target)}
		                   y2={y(target)}
		                   stroke={OMNI.GREEN}
		                   strokeDasharray="5 5"
		                   strokeWidth="1.5"
		                   opacity="0.6"
		               />

		               <path
		                   d={d}
		                   fill="none"
		                   stroke={OMNI.GREEN}
		                   strokeWidth="2"
		                   strokeLinecap="round"
		               />

		               {data.map(function (v, i) {

		                   if (i === 0) return null;

		                   let stroke = OMNI.GREEN;
		                   if (v < target - 1.5) stroke = OMNI.RED;
		                   else if (v < target) stroke = adjustColor(OMNI.PINK, -10);

		                   return (
		                       <line
		                           key={i}
		                           x1={(i - 1) * stepX}
		                           x2={i * stepX}
		                           y1={y(data[i - 1])}
		                           y2={y(v)}
		                           stroke={stroke}
		                           strokeWidth="2"
		                           opacity="0.9"
		                       />
		                   );
		               })}
		           </svg>
		       );
		   }
		   
		   
		   function generateAvailabilityData(days) {
		       const data = [];

		       for (let i = 0; i < days; i++) {
		           let v = 99.2 + (Math.random() - 0.5) * 1.2;

		           if (Math.random() > 0.9) {
		               v -= Math.random() * 3;
		           }

		           data.push(Math.max(94, Math.min(100, v)));
		       }

		       return data;
		   }
	
	
	
	   
	   
	  
		 
		 
		 return (
			<>
		
		 <div style={chartContainer}>
		 <div style={{minHeight:'40px'}}/>
		 <AvailabilityTimeline
            data={availabilityData}
            height={120}
            target={AVAIL_TARGET}
        />
         </div>
		 </>
		 );
}